import React from 'react';
import { TrainerData } from '.';
import {
  CardMedia,
  makeStyles,
  createStyles,
  Box,
  Avatar,
  Container,
  Typography,
  Chip,
} from '@material-ui/core';
import { nameRepresentation } from '../../utils/text-formatting';
import { TrainerDetails } from './trainer-details';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { Button } from 'gatsby-theme-material-ui';
import { DiscountPromo } from '../../features/promo/discount-promo/discount-promo';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { CheckList } from './check-list';
import { Price } from './price';
import { CurrentViews } from './current-views';
import { ActiveClients } from './active-clients';

interface Props {
  trainerData: TrainerData;
  location: Location;
}

const useStyles = makeStyles(({ spacing, palette, zIndex }) =>
  createStyles({
    root:{ 
      backgroundColor: palette.background.paper, 
    },
    coverImage: {
      height: 145,
    },
    navContainer: {
      color: palette.primary.contrastText,
      position: 'absolute',
      width: '100%',
      height: 145,
      background:
        'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(196, 196, 196, 0) 72.92%);',
      padding: spacing(1.5, 2),
    },
    avatar: {
      width: 100,
      height: 100,
      borderWidth: 4,
      borderColor: palette.primary.contrastText,
      marginTop: -70,
    },
    bottomButton: {
      position:"fixed",
      bottom:32,
      width:"100%",
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      zIndex: zIndex.appBar
    },
  })
);

export const TrainerProfileMobile: React.FC<Props> = ({ trainerData, location }) => {
  const classes = useStyles();
  const name = nameRepresentation(
    trainerData.first_name,
    trainerData.last_name
  );

  const handleStartTrial = () => {
    trackCustomEvent({
      category: "Start Trial",
      action: "Click",
      label: `${name}`,
      value: trainerData.price
    })
  }

  return (
    <Box className={classes.root}>
      <Box>
        <Box className={classes.navContainer}>
          <Button
            to="/trainers"
            color="inherit"
            size="large"
            startIcon={<ArrowBack />}
          >
            Back to Trainers
          </Button>
        </Box>
        <CardMedia
          className={classes.coverImage}
          image={trainerData.cover_image_url}
        />
      </Box>
      <Container>
        <Avatar alt={`${name} Profile Picture`} className={classes.avatar} src={trainerData.profile_pic_url} />
        <Box
          mt={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center">
            <Typography component="h1" variant="h6">{name}</Typography>
            <Box mr={2} />
            <Chip label="Verified" color="primary" size="small" />
          </Box>
          <Price trainerId={trainerData._id} value={trainerData.price} />
        </Box>
        <Box mt={1.5} />
        <Typography variant="subtitle2">
          {`${trainerData.available_spots} Available Spots Left`}
        </Typography>
        <Box mt={1} />
        <ActiveClients trainerId={trainerData._id} />
        <Box mt={1} />
        <CurrentViews />
        <Box mt={3} />
        <CheckList />
        <Box mt={3} />
        <TrainerDetails location={location} trainerData={trainerData} />
        <Box mt={2} />
      </Container>
      <Box className={classes.bottomButton}>
        <Button
          to={`/membership/${trainerData._id}`}
          fullWidth
          color="primary"
          variant="contained"
          size="large"
          onClick={handleStartTrial}
        >
          START 7-DAY FREE TRIAL NOW
        </Button>
      </Box>
    </Box>
  );
};
